export const staticDataDefaultRQConfig = {
  retry: false,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchOnReconnect: false,
  staleTime: Infinity,
};

export const defaultRQConfig = {
  retry: false,
};
